import { Injectable } from '@angular/core';
import { GenericService } from '../../../../core/services/GenericService';
import { ApiService } from '../../../../core/services';
import { ArticleLabelTypes } from '../enums/ArticleLabelTypes';
import { IArticleLabel } from '../interfaces/IArticleLabel';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ArticleLabelsService extends GenericService<IArticleLabel> {

  public constructor(
    public readonly apiService: ApiService
  ) {
    super(apiService);
  }

  public setBaseUrl(articleId: number): void {
    this.baseUrl = `/labels/article-labels/${ articleId }/labels`;
  }

  public regenerateLabel(id: string): Observable<void> {
    return this.apiService.post(`${ this.baseUrl }/${ id }/regenerate-label`);
  }

  public regenerateLabels(articleVariantId?: number): Observable<void> {
    let httpParams = new HttpParams();

    if (articleVariantId) {
      httpParams = httpParams.append('articleVariantId', articleVariantId);
    }

    return this.apiService.post(`${ this.baseUrl }/regenerate-labels`, {}, httpParams);
  }

  public getArticleLabelsKeys(articleVariantId?: number): Observable<{ labelKey: string; }[]> {
    let httpParams = new HttpParams();

    if (articleVariantId) {
      httpParams = httpParams.append('articleVariantId', articleVariantId);
    }

    return this.apiService.get(`${this.baseUrl}/keys`, httpParams);
  }

  public createInstant(articleId: number, articleVariantId: number, type: ArticleLabelTypes): Observable<IArticleLabel> {
    this.setBaseUrl(articleId);
    return this.create({
      articleId,
      articleVariantId,
      type,
      context: JSON.stringify({}),
    });
  }
}
